export const HilPresentationType = {
  Form:     'form',
  Chat:     'chat',
  Approval: 'approval',
  Info:     'info',
  Custom:   'custom',   // backend-defined; rendered by app-specific logic
} as const;

export type HilPresentationTypeValue = typeof HilPresentationType[keyof typeof HilPresentationType];
